import {BaseAppPrefs} from "../shared/BaseAppPrefs";

export class AppPrefs extends BaseAppPrefs {

  private static instance: AppPrefs;

  static getInstance() {
    if (!this.instance) {
      this.instance = new AppPrefs();
    }
    return this.instance;
  }

  private constructor() {
    super();
  }
}
